import { useUiTranslator } from "../../hooks/useUiTranslator";
import { customPalette } from "../../theme/theme";
import { BaseModal } from "../common/BaseModal/BaseModal";

import { ReactNode, useState } from "react";

import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";

export const BtnReturnToProjectList = (): ReactNode => {
  const t = useUiTranslator();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const handleCloseModal = (): void => {
    setIsModalOpen(false);
  };
  const handleOpenModal = (): void => {
    setIsModalOpen(true);
  };
  const handleClick = (): void => {
    navigate({
      to: "/",
    });
  };
  return (
    <Box
      height="1.1em"
      mr={1}
      sx={{
        borderLeftStyle: "solid",
        borderLeftWidth: "1px",
        borderColor: customPalette.secondary.main,
      }}
      display="flex"
      alignItems="center"
    >
      <Button variant="text" color="primary" onClick={handleOpenModal}>
        <Typography variant="body1">
          {t("CustomApp:buttons.ExitConfigurationButton", "Project list")}
        </Typography>
      </Button>
      <BaseModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={t("CustomApp:modal.ExitConfiguration.title", "To project list")}
        customSx={{
          minWidth: "30em",
          width: "25%",
          overflow: "auto",
        }}
      >
        <Typography variant="caption">
          {t(
            "CustomApp:modal.ExitConfiguration.note",
            "Warning: Unsaved changes will be lost.",
          )}
        </Typography>
        <Box display="flex" gap={2} justifyContent="space-evenly" mt={2}>
          <Button variant="outlined" color="primary" onClick={handleClick}>
            {t("CustomApp:buttons.ExitWithoutSavingButton", "Exit")}
          </Button>
        </Box>
      </BaseModal>
    </Box>
  );
};
